import * as React from 'react';
const IconCheckbox = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="white"
  >
    <rect width={19} height={19} x={0.5} y={0.5} stroke="#396DFF" rx={3.5} />
  </svg>
);
export default IconCheckbox;
